import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

@createModule('TechnicalPropertyPopup')
/**
 * product-filter module implementation.
 *
 * @author Robert Schork <robert.schork@namics.com>
 */
export class TechnicalPropertyPopup extends TerrificSpec {
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		$($ctx)
			.find('.js-property-popup-closer')
			.on('click', this._hidePropertyPopup.bind(this));

		$($ctx)
			.find('.js-m-technical-property-popup__tab-nav')
			.on('click', this._triggerTab.bind(this));

		resolve();
	}
	
	_hidePropertyPopup(ev: any) {
		$(ev.currentTarget)
			.parent()
			.parent()
			.removeClass('state-m-technical-property-popup--shown');
		$('html').removeClass('no-scrolling--without-scrollbar');
	}

	_triggerTab(ev: any) {
		var num = $(ev.currentTarget).index();
		$(ev.currentTarget)
			.addClass('m-technical-property-popup__tab-nav--active');
		$(ev.currentTarget)
			.siblings()
			.removeClass('m-technical-property-popup__tab-nav--active');
		$(ev.currentTarget)
			.parent()
			.next()
			.find('.m-technical-property-popup__tab-pane')
			.removeClass('m-technical-property-popup__tab-pane--active');
		$(ev.currentTarget)
			.parent()
			.next()
			.find('.m-technical-property-popup__tab-pane')
			.eq(num)
			.addClass('m-technical-property-popup__tab-pane--active');
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
	/**
	 * method to trigger public event
	 *
	 * @returns {void}
	 */
	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}
